import type { TenorGif } from '../../types/index.js';
import { buildQuery, type RequestFn } from '../http.js';

/** Attachment uploads (presigned S3 flow) and the Tenor GIF proxy. */
export function makeMediaApi(request: RequestFn) {
  return {
    // ---------- uploads ----------
    signUpload: (input: { name: string; size: number; mime: string }) =>
      request<{ uploadUrl: string; key: string; expiresAt: string; mime: string; name: string }>(
        '/api/uploads/sign',
        { method: 'POST', body: JSON.stringify(input) },
      ),
    completeUpload: (input: {
      key: string;
      name: string;
      mime: string;
      width?: number;
      height?: number;
      durationMs?: number;
      /** Voice notes: recorded 0..1 amplitude envelope (≤64 buckets). */
      waveform?: number[];
    }) =>
      request<{
        id: string;
        name: string;
        mime: string;
        size: number;
        url: string;
        width?: number;
        height?: number;
        durationMs?: number;
        waveform?: number[];
      }>('/api/uploads/complete', {
        method: 'POST',
        body: JSON.stringify(input),
      }),

    // ---------- GIF picker (Tenor proxy) ----------
    // Returns 503 + { error: 'tenor_not_configured' } when TENOR_API_KEY is
    // not set server-side. Caller surfaces "GIF picker not configured" then
    // instead of failing silently.
    gifsTrending: (limit = 24, pos?: string) =>
      request<{ results: TenorGif[]; next: string | null }>(
        `/api/gifs/trending${buildQuery({ limit, pos })}`,
      ),
    gifsSearch: (q: string, limit = 24, pos?: string) =>
      request<{ results: TenorGif[]; next: string | null }>(
        `/api/gifs/search${buildQuery({ q, limit, pos })}`,
      ),
  };
}
